import { FunctionComponent, useEffect, useMemo, useRef, useState } from "react";
import { Container, SecaoButao } from "../../../../components/formulario/styled";
import ModalExportar from "../../../../components/modalExportar";
import OpenExcelUniversal from "../../../../components/excel/OpenExcelUniversal";
import DonwloadPdf from "../../../../components/pdf/DonwloadPdf";
import SearchInput from "../../../../components/inputs/searchInput";
import { CorpoTable, Tabela, TabelaCabeca, TabelaCorpo, Tabler } from "../../../../components/formulario/tableStyled";
import GetCargoList from "../services/getCargo";
import useNav from "../../../../hooks/useNav";
import { ButtonAdd } from "../../../../components/modalIncluir/buttonAdd";


interface TabelaMembrosBatismoProps {

}

const TabelaGrupoSede: FunctionComponent<TabelaMembrosBatismoProps> = () => {

  const [pesquisaPorMinisterio, setPesquisaPorMinisterio] = useState<string>('');


  const { getWithParams, listAll, nextPagina, pagina, reset } = GetCargoList()

  const {
    navTo
  } = useNav();

  const devRef = useRef<HTMLElement>(null);

  useMemo(() => {
    listAll?.slice(0, ((pagina + 1) * 30))
  }, [pagina]);

  useEffect(() => {
    if (devRef.current) {
      devRef.current.addEventListener('scroll', (e: any) => {
        if (e.target?.scrollTop >= (e.target.scrollHeight - (e.target.clientHeight + 60))) {
          nextPagina()
        }
      })
    }
  }, [devRef])

  const Td = () => <>
    {
      listAll
        ?.filter(
          element =>
            String(
              element?.['nomeevento']).toLocaleLowerCase().normalize('NFD')
              .replace(/[\u0300-\u036f]/g, "")
              .match(
                pesquisaPorMinisterio.toLocaleLowerCase().normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, "")
              ) ||
            String(
              element?.['nome']).toLocaleLowerCase().normalize('NFD')
              .replace(/[\u0300-\u036f]/g, "")
              .match(
                pesquisaPorMinisterio.toLocaleLowerCase().normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, "")
              )
        )
        ?.map(
          (element: any) => <tr onClick={() => navTo(String(element['id']))}>

            {
              ['nomegrupo', 'descricao', 'cargopai', 'codigo']?.map(
                des => <td>{element[des]}</td>
              )
            }

          </tr>)
    }
  </>

  return (<>
    <div style={{ display: "flex", flex: 1, padding: 5 }}>
      <Container>
        <SecaoButao style={{ marginBottom: 5 }}>
          <section style={{ display: 'flex', gap: 5 }}>
            <ModalExportar
              callDownloadExcel={() => OpenExcelUniversal(listAll, ['descricao'])}
              callDownloadPdf={() => DonwloadPdf(listAll,
                ['Descrição'],
                ['descricao'],
                listAll?.length, [], `${listAll?.length}`)
              }
            />
          </section>
          <SearchInput
            placeholder="Procure pela descrição"
            onChange={(e) => setPesquisaPorMinisterio(e.target.value.replace(/script/g, ""))} />

          <ButtonAdd action={() => { navTo('add') }} title="ADICIONAR" />
        </SecaoButao>
        <Tabler>
          {/*@ts-ignore*/}
          <CorpoTable ref={devRef}>
            <Tabela>
              <>
                <TabelaCabeca>
                  <tr>
                    {
                      ['Grupo Cargo', 'Descrição', 'Cargo Pai', 'Código']?.map(
                        res => <th>{res}</th>
                      )
                    }
                  </tr>
                </TabelaCabeca>
                <TabelaCorpo>
                  <Td />
                </TabelaCorpo>
              </>
            </Tabela>
          </CorpoTable>
        </Tabler>
      </Container>
    </div>
  </>);
}

export default TabelaGrupoSede;
